var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReTotalConsumerIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 15.0134 20.6672 17.7154 18.5588 19.5488C16.8031 21.0756 14.5095 22 12 22C9.49052 22 7.19694 21.0756 5.44117 19.5488C3.33285 17.7154 2 15.0134 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 19C13.7567 19 15.3622 18.3529 16.5912 17.2842C16.7327 17.1611 16.8692 17.0325 17.0003 16.8986C15.9194 15.1503 14.0833 14 12 14C9.91675 14 8.0806 15.1503 6.99969 16.8986C7.13086 17.0325 7.26735 17.1611 7.40884 17.2842C8.63788 18.3529 10.2434 19 12 19ZM12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z",
    fill: "#6B7DE5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReTotalConsumerIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RE_TotalConsumer_icon.116fd99164c56293271e28cf9b7c8d73.svg";